import type { Translations } from "../../client/i18n/translations";
import type { DrawdownType } from "./types";

/** i18n label for a drawdown type. Shared by the offer row and card. */
export function drawdownTypeLabel(t: Translations, type: DrawdownType): string {
  switch (type) {
    case "eod":
      return t.comparator.ddEod;
    case "eot":
      return t.comparator.ddEot;
    case "trailing":
      return t.comparator.ddTrailing;
    case "static":
      return t.comparator.ddStatic;
  }
}

/** Semantic color class for an editorial rating: emerald ≥8, amber 4–8, red <4. */
export function ratingClass(rating: number | null): string {
  if (rating == null) return "text-muted-foreground";
  if (rating >= 8) return "text-emerald-500";
  if (rating >= 4) return "text-amber-500";
  return "text-red-500";
}
